import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../../../lib/api-client';
import { ActionHistoryDetail } from '../../../common/action-history-grid/types/ActionHistoryDetail';

export const useGetEstimateActionHistory = (quoteID: number, enabled: boolean) => {

    const { data, isLoading } = useQuery({
        queryKey: ['estimate-action-history', quoteID],
        queryFn: async () => await apiClient.get('estimate/action-history',
            { params: { quoteID: quoteID } }) as ActionHistoryDetail[],
        enabled: enabled
    });

    return {
        data: data || [],
        isLoading: isLoading
    };
};
